export enum UiContextActionType {
  EnableImageEditorFullScreenMode = 'enableImageEditorFullScreenMode',
  EnableTextEditorFullScreenMode = 'enableTextEditorFullScreenMode',
  ShowDataGrid = 'showDataGrid',
  HideDataGrid = 'hideDataGrid',
  StartBackgroundOperation = 'startBackgroundOperation',
  EndBackgroundOperation = 'endBackgroundOperation',
  EndBackgroundOperationsByType = 'endBackgroundOperationsByType',
}
